import { injectable } from 'inversify'
import * as Sentry from '@sentry/react'

const appEnv = import.meta.env.VITE_APP_ENV
const isDev = appEnv === 'development'

export type LogPayload = {
  msg: string
  err?: any
  context?: Record<string, any>
}

@injectable()
export class LoggingService {
  error(payload: LogPayload) {
    const { msg, err, context } = payload

    if (isDev) {
      console.error(err, JSON.stringify(context, null, 2))
    } else {
      // Ensure we have an Error object for Sentry
      const error = err instanceof Error ? err : new Error(msg)

      Sentry.captureException(error, {
        extra: {
          reason: msg,
          context,
          originalError: err,
        },
      })
    }
  }

  info(payload: LogPayload) {
    const { msg, context } = payload

    if (isDev) {
      console.log(msg, JSON.stringify(context, null, 2))
    } else {
      Sentry.addBreadcrumb({
        message: msg,
        data: context,
        level: 'info',
      })
    }
  }

  warn(payload: LogPayload) {
    const { msg, context } = payload

    if (isDev) {
      console.warn(msg, JSON.stringify(context, null, 2))
    } else {
      Sentry.addBreadcrumb({
        message: msg,
        data: context,
        level: 'warning',
      })
    }
  }

  debug(payload: LogPayload) {
    const { msg, context } = payload

    if (isDev) {
      console.log(msg, JSON.stringify(context, null, 2))
    } else {
      // Optionally log debug info as breadcrumbs in production
      Sentry.addBreadcrumb({
        message: msg,
        data: context,
        level: 'debug',
      })
    }
  }
}
